import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Button, ButtonToolbar } from "react-bootstrap";
import Uppy from '@uppy/core';
import DragDrop from '@uppy/drag-drop';
import Tus from '@uppy/tus';
import './AddContentButton.scss';

class AddContentButton extends Component {
  constructor(props) {
    super(props);

    this.uppy = null;
  }

  componentDidMount() {
    super.componentDidMount && super.componentDidMount();
  }

  onClickContainer = e => {
    e.preventDefault();
    this.props.onClick();
  }

  render() {
    const selCollection = this.props.collectionEvent.collection;
    const isEditable = this.props.isAdmin || (selCollection && (!selCollection.sharedBy || (this.props.user && selCollection.sharedBy === this.props.user.userId)))

    return (
      <div className="add-content-button" onClick={this.onClickContainer}>
        {!(this.props.collectionState === 'collectionEditing' && !isEditable) && (
          <ButtonToolbar
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            onClick={() => this.props.openUploadModal()}
          >
            <Button variant="danger" className="btn-danger">
              <FontAwesomeIcon icon={faPlus} />
            </Button>
            <span>{this.props.collectionState === 'collectionEditing' && isEditable ? 'Add new content to collection' : 'Add new content'}</span>
          </ButtonToolbar>
        )}
        <div className="for-DragDrop"></div>
      </div>
    )
  }
}

export default AddContentButton;
